import { render, staticRenderFns } from "./EnterPhone.vue?vue&type=template&id=74de2443&"
import script from "./EnterPhone.vue?vue&type=script&lang=js&"
export * from "./EnterPhone.vue?vue&type=script&lang=js&"
import style0 from "./EnterPhone.vue?vue&type=style&index=0&id=74de2443&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports